import { render, staticRenderFns } from "./newPageTemplate.vue?vue&type=template&id=ad048f54&"
import script from "./newPageTemplate.vue?vue&type=script&lang=js&"
export * from "./newPageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports